import React from 'react';

// @mui
import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    Alert,
    AlertTitle,
    Drawer,
    Box
} from '@mui/material';

import i18n from 'i18';
import { LoadingButton } from '@mui/lab';
import Fields from '../fields';
import { formatError } from '../../utils/formatError';

export default class CustomAddXDialog extends React.Component {
    onClose = () => {};
    onSave = () => {};
    Head;
    server;
    title;
    constructor(props) {
        super(props);

        this.state = {
            dialogOpen: props.dialogOpen || false,
            data: {},
            alertText: ''
        };

        this.onClose = props.onClose;
        this.onSave = props.onSave;
        this.Head = props.head;
        this.server = props.server;
        this.title = props.title;
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dialogOpen !== state.dialogOpen) {
            return {
                dialogOpen: props.dialogOpen,
                data: {},
                alertText: ''
            };
        }
        return null;
    }

    handleValueChanged(id, value) {
        this.setState((state) => {
            const data = state.data;
            data[id] = value;
            return { data };
        });
    }

    handleDialogClose() {
        this.onClose();
    }

    handleDialogSave() {
        const { data } = this.state;
        this.server.addX(data).then((response) => {
            if (response.error !== 'OK') {
                this.setState({ alertText: formatError(response) });
            } else {
                this.onSave();
            }
        });
    }
    handleSaveAndOpenPdf() {
        const { data } = this.state;
        this.server.addXPdf(data).then((response) => {
            if (response.error !== 'OK') {
                const error = formatError(response);
                this.setState({ alertText: error });
            } else {
                this.onSave();
                window.open(URL.createObjectURL(response.blob));
            }
        });
    }

    render() {
        const { data } = this.state;
        return (
            <Drawer
                open={this.state.dialogOpen}
                onClose={(event) => this.handleDialogClose()}
                anchor="right"
                ModalProps={{
                    keepMounted: true
                }}
                sx={{
                    "width": { sm: '100%', md: '40%', lg: '30%' },
                    '& .MuiDrawer-paper': {
                        width: { sm: '100%', md: '40%', lg: '30%' },
                        overflow: 'auto',
                        boxSizing: 'border-box'
                    }
                }}
            >
                <DialogTitle>{this.title}</DialogTitle>
                <DialogContent
                    sx={{
                        padding: 0,
                        borderTop: '1px solid #E4E7EC',
                        borderBottom: '1px solid #E4E7EC',
                        position: 'relative'
                    }}
                >
                    <Box sx={{ padding: '20px 24px' }}>
                        {this.state.alertText && (
                            <Alert severity="error">
                                <AlertTitle>{i18n.t('text.error')}</AlertTitle>
                                {this.state.alertText}
                            </Alert>
                        )}
                        {this.Head.map((field) => {
                            let Field = Fields[field.cell];
                            if (!Field) Field = Fields.Text; // fallback to text
                            if (field.disableEditor) return null;
                            return (
                                <Field
                                    key={field.id}
                                    field={field}
                                    value={data?.[field?.id] || null}
                                    onChange={(id, value) =>
                                        this.handleValueChanged(id, value)
                                    }
                                />
                            );
                        })}
                    </Box>
                </DialogContent>
                <DialogActions sx={{ '& .MuiButton-root': { height: 42 } }}>
                    <Button
                        disabled={this.state.loading}
                        color="secondary"
                        variant="outlined"
                        sx={{ height: '100%' }}
                        onClick={(event) => this.handleDialogClose(event)}
                    >
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <LoadingButton
                        fullWidth
                        color="primary"
                        variant="contained"
                        sx={{ height: '100%' }}
                        loading={this.state.loading}
                        onClick={(event) => this.handleDialogSave(event)}
                    >
                        {i18n.t('buttons.save')}
                    </LoadingButton>
                    <LoadingButton
                        fullWidth
                        color="primary"
                        variant="contained"
                        sx={{ height: '100%' }}
                        loading={this.state.loading}
                        onClick={(event) => this.handleSaveAndOpenPdf(event)}
                    >
                        {i18n.t('buttons.saveAndOpenPdf')}
                    </LoadingButton>
                </DialogActions>
            </Drawer>
        );
    }
}
